var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","overflow-y":"scroll"}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.codeList,"border":""}},[_c('el-table-column',{attrs:{"prop":"code","label":"国际名缩写"}}),_c('el-table-column',{attrs:{"prop":"name","label":"国家或地区"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }